import { BrowserConfigType, ModulePath, ModuleSignMap } from "./types";
import {
  hrmProfileModule,
  performanceModule,
  documentModule,
  attendModule,
  formDataReportModule,
  formReportModule,
  planModule,
  workflowModule,
  ebuilderModule,
  customerModule,
} from './modules';

/* 系统各个模块提供的弹框组件 */
const defaultModulePath: ModulePath[] = [];

/* 如果模块存在多个事项卡片，可以针对每种事项卡片创建一个标示 */
export const moduleSignToModule: ModuleSignMap = {
  // 测试模块
  "demo": {
    module: 'common',
    type: 'demo',
    paths: [
      // 用于测试模块
      { app: '@weapp/demo', compName: 'DemoViewDialog' },
      { app: '@weapp/demo', compName: 'DemoViewSideDialog' }, 
    ],
  },
  // 人力资源
  "hrmProfile": hrmProfileModule,
  "hruserinfo": hrmProfileModule,
  // 人事合同
  "hrcontract": {
    module: 'hrm',
    mListPath: '',
    mDetailPath: '/mobile/hrm/contractManager/info/{id}',
    detailPath: '/sp/hrm/contract/{id}',
    paths: [
      { app: '@weapp/hrm', compName: 'HrmContractViewDialog' },
      { app: '@weapp/hrm', compName: 'HrmContractViewSideDialog' },
    ],
  },
  // 考勤订阅
  "subscribe": attendModule,
  "subscript": attendModule,
  "subscribeattend": attendModule,
  // 订阅日报
  "subscribeblog": {
    module: 'blog',
    mDetailPath: '/mobile/blog/subscribe/{id}',
    paths: [
      { app: '@weapp/blog', compName: 'BlogSubscriptionDialog' },
      { app: '@weapp/blog', compName: 'BlogSubscriptionDialog' },
    ]
  },
  // 订阅报告
  "subscribeworkreport": {
    module: 'plan',
    mDetailPath: '/mobile/plan/subscribe/{id}',
    paths: [
      { app: '@weapp/plan', compName: 'WorkreportSubscriptionDialog' },
      { app: '@weapp/plan', compName: 'WorkreportSubscriptionDialog' },
    ],
  },
  // 异常申述
  "attendAppeal": {
    module: "attend",
    paths: [
      { app: "@weapp/attend", compName: "AbnormalAppealDialog" },
      { app: "@weapp/attend", compName: "AbnormalAppealSideDialog" },
    ]
  },
  // 项目
  "mainline": {
    module: "project",
    type: ["mainlineBrowser", "belongMainlineBrowser"],
    mListPath: '/mobile/project',
    mDetailPath: '/mobile/project/details/{id}',
    detailPath: '/sp/project/projectViewPage/{id}',
    addPaths: [
      { app: '@weapp/project', compName: 'ProjectViewDialog' },
    ],
    paths: [
      { app: '@weapp/project', compName: 'ProjectViewDialog' },
      { app: '@weapp/project', compName: 'ProjectViewSideDialog' },
    ],
  },
  // 项目报告
  "mainlineReport": {
    module: 'project',
    mListPath: '',
    mDetailPath: '/mobile/project/mainlinereport/{id}',
    detailPath: '',
    paths: [
      { app: '@weapp/project', compName: 'ProjectReportViewDialog' },
      { app: '@weapp/project', compName: 'ProjectReportViewDialog' },
    ],
  },
  // "任务"
  "task": {
    module: "task",
    type: ["taskBrowser", "preTaskBrowser", "postTaskBrowser"],
    mListPath: '/mobile/task',
    mDetailPath: '/mobile/task/taskDetail/{id}',
    detailPath: '/sp/task/taskViewPage/{id}',
    addPaths: [
      { app: '@weapp/task', compName: 'TaskViewDialog' },
    ],
    paths: [
      { app: '@weapp/task', compName: 'TaskViewDialog' },
      { app: '@weapp/task', compName: 'TaskViewSideDialog' },
    ]
  },
  // 日程模块
  "calendar": {
    module: "calendar",
    type: "calendarBrowser",
    mListPath: '/mobile/calendar',
    mDetailPath: '/mobile/calendar/detail/{id}',
    detailPath: '/sp/calendar/calendarViewPage/{id}',
    addPaths: [
      { app: '@weapp/calendar', compName: 'CalendarViewDialog' },
    ],
    paths: [
      { app: '@weapp/calendar', compName: 'CalendarViewDialog' },
      { app: '@weapp/calendar', compName: 'CalendarViewSideDialog' },
    ],
  },
  // "报告"
  "workreport": planModule,
  "plan": planModule,
  // 日报
  "blog": {
    module: 'blog',
    type: 'blogBrowser',
    mListPath: '/mobile/blog/their',
    mDetailPath: '/mobile/blog/blogdetail/{id}',
    detailPath: '/sp/blog/blogdetail/{id}',
    paths: [
      // 微博模块
      { app: '@weapp/blog', compName: 'BlogViewDialog' },
      { app: '@weapp/blog', compName: 'BlogViewSideDialog' },
    ],
  },
  // 绩效
  "kpiFlow": performanceModule,
  "performance": performanceModule,
  // 绩效-im消息（方案）
  "kpiSchemeSetting": {
    module: 'performance',
    mListPath: '/mobile/performance/scheme',
    mDetailPath: '/mobile/performance/schemeDetail/{id}',
    detailPath: '',
    paths: [
      { app: '@weapp/performance', compName: 'PerofrmanceSchemeViewDialog' },
      { app: '@weapp/performance', compName: 'PerformanceSchemeViewSideDialog' },
    ],
  },
  // 目标
  "goal": {
    module: 'goal',
    type: 'goalBrowser',
    mListPath: '/mobile/goal',
    mDetailPath: '/mobile/goal/open?id={id}',
    detailPath: '/sp/goal/openDetail/?id={id}',
    addPaths: [
      { app: '@weapp/goal', compName: 'AddGoalMangager' },
    ],
    paths: [
      // 任务模块
      { app: '@weapp/goal', compName: 'GoalViewDialog' },
      { app: '@weapp/goal', compName: 'GoalViewSideDialog' },
    ],
  },
  // 审批
  "workflow": workflowModule,
  'workflow/core': workflowModule,
  // 邮件
  "mail": {
    module: 'mail/base',
    type: 'mailResource',
    mListPath: '/mobile/mail',
    mDetailPath: '/mobile/mail/view/{id}',
    detailPath: '/sp/mail/view?mailResourceId={id}',
    addPaths: [
      { app: '@weapp/mail', compName: 'MailNewDialog' },
    ],
    paths: [
      { app: '@weapp/mail', compName: 'MailViewDetailDialog' },
      { app: '@weapp/mail', compName: 'MailViewDetailSideDialog' },
    ],
  },
  // 知识文档
  "document": documentModule,
  "doc": documentModule,
  // 文件夹
  "folder": {
    module: 'doc',
    type: 'folder',
    mListPath: '/mobile/doc/docList/{id}',
    mDetailPath: '/mobile/doc/docList/{id}',
    detailPath: '/doc/knowledge/{id}',
    addPaths: [
      { app: '@weapp/doc', compName: 'FolderViewDialog' },
    ],
    paths: [
      { app: '@weapp/doc', compName: 'FolderViewDialog' },
      { app: '@weapp/doc', compName: 'FolderViewSideDialog' },
    ],
  },
  // 业务表单
  "biaoge": formReportModule,
  // 关联表单字段
  "frpt_component": {
    module: "formdatareport",
    type: "frpt_component",
    mListPath: '/mobile/formreport',
    mDetailPath: '/mobile/formreport/dataDetail/{id}',
    detailPath: '',
    addPaths: [
      { app: 'weapp-formreport', compName: 'FormreportNewViewDialog' },
    ],
    paths: [
      // 表单数据
      { app: '@weapp/formreport', compName: 'FormreportViewDialog' },
      { app: '@weapp/formreport', compName: 'FormreportViewSideDialog' },
    ],
  },
  // 表单数据
  "frpt_form": formDataReportModule,
  "formreport": formDataReportModule,
  "formdatareport": formDataReportModule,
  // ebuilder
  "ebuilder": ebuilderModule,
  "ebuilderform": ebuilderModule,
  // 数据规则
  "datarule": {
    module: 'datarule',
    addPaths: [
      { app: 'weapp-datarule', compName: 'DataruleViewDialog' },
    ],
    paths: [
      // 数据规则
      { app: '@weapp/datarule', compName: 'DataruleViewDialog' },
      { app: '@weapp/datarule', compName: 'DataruleViewSideDialog' },
    ],
  },
  // 公告
  "placard": {
    module: 'placard',
    mListPath: '/mobile/placard/list',
    mDetailPath: '/mobile/placard/page/{id}',
    detailPath: '',
    paths: [
      { app: '@weapp/placard', compName: 'PlaCardListMiddleDiagLog' },
      { app: '@weapp/placard', compName: 'PlaCardListRightDiaLog' },
    ],
  },
  /* ============== CRM ============== */
  // "客户"
  "customer": customerModule,
  // 客户重复提醒
  "sameCustomer": customerModule,
  // "联系人"
  "contact": {
    module: "crm",
    type: "contact",
    mListPath: '/mobile/crm/contact',
    mDetailPath: '/mobile/crm/contact/0/contactInfo/{id}',
    detailPath: '/sp/crm/contact/contactViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateContactDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmContactViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmContactViewDialogProvider' },
    ],
  },
  // "商机"
  "saleChance": {
    module: "crm",
    type: "saleChance",
    mListPath: '/mobile/crm/salechance',
    mDetailPath: '/mobile/crm/salechance/0/saleChanceInfo/{id}',
    detailPath: '/sp/crm/saleChance/saleChanceViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateSaleChanceDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmSaleChanceViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmSaleChanceViewDialogProvider' },
    ],
  },
   // "线索"
   "clue": {
    module: "crm",
    type: "clue",
    mListPath: '/mobile/crm/clue',
    mDetailPath: '/mobile/crm/clue/0/clueInfo/{id}',
    detailPath: '/sp/crm/clue/clueViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateClueDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmClueViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmClueViewDialogProvider' },
    ],
  },
  // "合同"
  "contract": {
    module: "crm",
    type: "contract",
    mListPath: '/mobile/crm/contract',
    mDetailPath: '/mobile/crm/contract/0/contractInfo/{id}',
    detailPath: '/sp/crm/contract/contractViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateContractDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmContractViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmContractViewDialogProvider' }, 
    ],
  },
  // 竞争对手
  "competitor": {
    module: "crm",
    type: "competitor",
    mListPath: '/mobile/crm/competitor',
    mDetailPath: '/mobile/crm/competitor/0/competitorInfo/{id}',
    detailPath: '/sp/crm/competitor/competitorViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateContractDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmCompetitorViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmCompetitorViewDialogProvider' }, 
    ],
  },
  // 订单
  "orderform": {
    module: "crm",
    type: "orderform",
    mListPath: '/mobile/crm/orderform',
    mDetailPath: '/mobile/crm/orderform/0/orderformInfo/{id}',
    detailPath: '/sp/crm/orderform/orderformViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateOrderFormDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmOrderFormViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmOrderFormViewDialogProvider' }, 
    ],
  },
  // 价格
  "price": {
    module: "crm",
    type: "price",
    mListPath: '/mobile/crm/price',
    mDetailPath: '/mobile/crm/price/0/priceInfo/{id}',
    detailPath: '/sp/crm/price/priceViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreatePriceDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmPriceViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmPriceViewDialogProvider' }, 
    ],
  },
  // "产品"
  "production": {
    module: "crm",
    type: "production",
    mListPath: '/mobile/crm/production',
    mDetailPath: '/mobile/crm/production/0/productionInfo/{id}',
    detailPath: '/sp/crm/production/productionViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateProductionDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmProductionViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmProductionViewDialogProvider' },
    ],
  },
  // "市场活动"
  "marketactivity": {
    module: "crm", 
    type: "marketactivity",
    mListPath: '/mobile/crm/marketactivity',
    mDetailPath: '/mobile/crm/marketactivity/0/marketActivityInfo/{id}',
    detailPath: '/sp/crm/marketactivity/marketactivityViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateMarketActivityDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmMarketActivityViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmMarketActivityViewDialogProvider' },
    ],
  },
  // 报价
  "quote": {
    module: "crm", 
    type: "quote",
    mListPath: '/mobile/crm/quote',
    mDetailPath: '/mobile/crm/quote/0/quoteInfo/{id}',
    detailPath: '/sp/crm/quote/quoteViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateQuoteDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmQuoteViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmQuoteViewDialogProvider' },
    ],
  },
  // 资金
  "capital": {
    module: "crm", 
    type: "capital",
    mListPath: '/mobile/crm/capital',
    mDetailPath: '/mobile/crm/capital/0/capitalInfo/{id}',
    detailPath: '/sp/crm/capital/capitalViewPage/{id}',
    addPaths: [
      { app: '@weapp/crm', compName: 'CrmCreateCapitalDialogProvider' },
    ],
    paths: [
      { app: '@weapp/crm', compName: 'CrmCapitalViewMiddleDialog' },
      { app: '@weapp/crm', compName: 'CrmCapitalViewDialogProvider' },
    ],
  },
  // 公海回归前提醒
  "releaseRemind": {
    module: 'crm',
    paths: [
      { app: '@weapp/crm', compName: 'CrmCustomerIMMessageDialog' },
      { app: '@weapp/crm', compName: 'CrmCustomerIMMessageDialog' },
    ],
  },
  // 公海自动回归
  "releaseCustomer": {
    module: 'crm',
    paths: [
      { app: '@weapp/crm', compName: 'CrmCustomerIMMessageDialog' },
      { app: '@weapp/crm', compName: 'CrmCustomerIMMessageDialog' },
    ],
  },
  // 线索提醒
  "myclue": {
    module: 'crm',
    paths: [
      { app: '@weapp/crm', compName: 'CrmClueIMMessageDialog' },
      { app: '@weapp/crm', compName: 'CrmClueIMMessageDialog' },
    ],
  },
  // 延期提醒
  "mycontactremind": {
    module: 'crm',
    paths: [
      { app: '@weapp/crm', compName: 'ContactRemindListDialogProvider' },
      { app: '@weapp/crm', compName: 'CrmCustomerIMMessageDialog' },
    ],
  },
  // 到期提醒(联系提醒)
  "contactRemind": {
    module: 'crm',
    mDetailPath: '{host}/mobile/crm/remind/remindList/0/0/info/:id',
    paths: [
      { app: '@weapp/crm', compName: 'ContactRemindViewDialogProvider' },
      { app: '@weapp/crm', compName: 'ContactRemindViewDialogProvider' },
    ],
  },
  // 预警报告
  "warningReportMsg": {
    module: 'crm',
    paths: [
      { app: '@weapp/crm', compName: 'CrmSaleChanceWarningMessageDialog' },
      { app: '@weapp/crm', compName: 'CrmSaleChanceWarningMessageDialog' },
    ],
  },
};

// 各模块新老module对应关系以及对应的事项关联按钮type
export const associatedBrowserConfig: BrowserConfigType = {
  "calendar": {
    module: "calendar", // "日程"
    type: "calendarBrowser"
  },
  "production": {
    module: "crm", // "产品"
    type: "production"
  },
  "marketactivity": {
    module: "crm", // "活动"
    type: "marketactivity"
  },
  "mainline": {
    module: "project", // "项目"
    type: "mainlineBrowser"
  },
  "saleChance": {
    module: "crm", // "商机"
    type: "saleChance"
  },
  "contract": {
    module: "crm", // "合同"
    type: "contract"
  },
  "kpiFlow": {
    module: "performance",
    type: "performanceBrowser"
  },
  "frpt_form": {
    module: "formreport",
    type: "frpt_form"
  },
  "task": {
    module: "task", // "任务"
    type: "taskBrowser"
  },
  "competitor": {
    module: "crm", // "对手"
    type: "competitor"
  },
  "clue": {
    module: "crm", // "线索"
    type: "clue"
  },
  "contact": {
    module: "crm", // "联系人"
    type: "contact"
  },
  "workreport": {
    module: "plan", // "报告"
    type: "planBrowser"
  },
  "formdatareport": {
    module: "formdatareport",
    type: "frpt_component"
  },
  "customer": {
    module: "crm", // "客户"
    type: "customer"
  },
  "subscribe": {
    module: "subscript", // "出勤"
  },
  "attendAppeal": {
    module: 'attendAppeal',
  },
  "hruserinfo": {
    module: "hrmProfile", // "人事"
  },
  "hrcontract": {
    module: "hrcontract",
  },
  // "workflow","审批"
  // "blog","日报"
  // "statisticalReport","统计"
  // "wechatEnterprise","企微"
  // "form","表单"
  // "wechatService","服务号"
  // "sms","短信"
  // "saleTarget","目标"
  // "crmSummary","统计"
  // "salarybill","工资单"
  // "placard","公告"
  // "staffPosition","位置"
  // "app","PAAS"
  // "email","邮件"
  // "kpi","绩效"
  // "orderform","订单"
  // "price","价格"
  // "tag","标签"
  // "capital","资金"
  // "room","会议"
  // "quote","报价"
  // "signcontract","电子签"
  // "invoice","发票"
  // "CRM","CRM"
  // "market", "营销"
  // "fna", "云报销"
}

export default defaultModulePath;
